import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    width?: number;
    height?: number;
};
export const WaterDispenserIcon = (props: Props) => {
    const { width = 20, height = 38, fill = 'currentColor', ...restProps } = props;
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();

    return (
        <svg xmlns="http://www.w3.org/2000/svg"  width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 20 38" fill="none" {...restProps}>
            <g clip-path="url(#clip0_13242_21159)">
                <path 
                    d="M10.0805 13.7648C12.2965 13.7648 14.1015 11.88 14.1015 9.55758C14.1015 7.58016 11.3376 2.3884 10.7816 1.37024C10.4915 0.840127 9.66956 0.840127 9.37947 1.37024C8.82347 2.3884 6.05957 7.58016 6.05957 9.55758C6.05957 11.88 7.86457 13.7648 10.0805 13.7648ZM10.0805 3.53278C11.2086 5.7458 12.4899 8.58149 12.4899 9.55758C12.4899 10.946 11.4101 12.0819 10.0805 12.0819C8.75095 12.0819 7.67117 10.946 7.67117 9.55758C7.67117 8.58149 8.9524 5.7458 10.0805 3.53278Z" 
                    fill={fill}/>
                <path 
                    d="M18.3803 12.7812L16.6317 36.3167H3.36019L2.25625 21.4903H15.971V19.8074H2.13537L1.6116 12.7812H0L1.81305 37.2255C1.84529 37.663 2.19178 37.9996 2.61886 37.9996H17.3811C17.8002 37.9996 18.1547 37.663 18.1869 37.2255L20 12.7812H18.3803Z" 
                    fill={fill}/>
            </g>
            <defs>
                <clipPath id="clip0_13242_21159">
                    <rect width="20" height="38" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
};
